<!-- eslint-disable max-len -->
<template>
  <div class="max960 mid bg-w box">
    <div class="horiz p1 ol-b bg-p2">
      <img class="h-start" src="../../images/logo_flat.svg" height="32px"/>
    </div>
    <div class="al-l p3">
      <h1> Terms of Use</h1>
      <p>Effective date: January 18, 2020</p>

      <p>Welcome to Investor's AI, LLC.  For purposes of this agreement, “Site” refers to the Investor’s AI website,
        which can be accessed at investors-ai.com. “Service” refers to "Investor's AI, LLC" services accessed via the
        Site, in which investment advisors can get allocation recommendations for their client accounts. The terms
        “Investor’s AI”, “we,” “us,” and “our” refer to the Company. “You” refers to you, as a user of our Site or our
        Service. </p>
      <p>The Service is provided with the intention to allow investment advisors to manage, generate and email investment allocation
        recommendations for their clients.</p>
      <p>Please review the following terms carefully. By accessing or using the Service, you signify your agreement to
        these Terms of Use. If you do not agree to be bound by these Terms of Use in their entirety, you may not access
        or use the Service.  The following Terms of Use apply when you view or use the “Clients” Service via our website located at
        investors-ai.com/clients. </p>
      <p>Please refer to the Company’s Privacy Policy (found here: investors-ai.com/privacy) which explains how we
        collect, use, and disclose information that pertains to your privacy. When you access or use the Service, you
        signify your agreement to the Privacy Policy as well as these Terms of Use.</p>

      <h2>FEES AND PAYMENT</h2>
      <p>In consideration for the access to and use of the Service, you shall pay Investor’s AI the fees determined
        according to the payment plan that you have selected at registration. You must provide accurate information
        regarding your credit card or other payment instrument, and you must promptly update your payment information
        if such information changes. You hereby authorize Investor’s AI to periodically bill your payment instrument
        in advance, in accordance with the payment plan you have selected. If you wish to dispute any charges, you
        must provide notice to Investor’s AI of such dispute within sixty (60) days of payment of the disputed charge.
        All amounts paid are non-refundable.</p>
      <p>We reserve the right to change our prices at any point. If we do change prices, we will provide notice to
        you through the Website or via email, at our option, at least thirty (30) days before such change is to take
        effect. Your continued use of the Service after the price change constitutes your agreement to pay the changed
        amount; provided, however, that if you have purchased an annual Service subscription, the price change will
        not go into effect until the end of your then-current subscription period.</p>

      <h2>INVESTMENT DISCLAIMER</h2>
      <p>Investor’s AI Clients is intended for use by licensed financial professionals only.  It is not for client or
        general public use.  It is not intended as investment advice, nor as an endorsement, recommendation or
        sponsorship of any company, security or fund, Investor’s AI, has no fiduciary relationship
        with subscribers or clients of those subscribers.  You, as the investment advisor, are responsible for all
        investment recommendations and their suitability for your clients.</p>

      <h2>REGISTRATION</h2>
      <p>You need to be a registered financial advisor and a resident of the United States to register for and use the
        Service.  If you are a user who signs up for the Service, you will create a personalized account which includes
        a unique username and password to access the Service and to receive messages from the Company. You agree to
        notify us immediately of any unauthorized use of your password and/or account. The Company will not be
        responsible for any liabilities, losses, or damages arising out of the unauthorized use of your member name,
        password and/or account.</p>

      <h2>ACCESS AND USE</h2>
      <p>Subject to the terms and conditions of this Agreement, Investor’s AI will provide access to and use of the
        Service to you ("Subscriber"). We will also provide access to and use of the Service to any other individual
        authorized by Subscriber (each, an "Authorized User"). Subscriber acknowledges that each Authorized User must
        agree to these Terms of Service and the Privacy Policy prior to use and that Subscriber shall be responsible
        for ensuring compliance by each Authorized User with these Terms of Service and for any breach of these Terms
        of Service by any Authorized User.</p>
      <p>Subscriber is solely responsible for any data or content uploaded, stored or sent through the Service by
        Subscriber ("Subscriber Data"). In no event shall Investor’s AI be responsible for the use or misuse of any
        Subscriber Data by Subscriber or any Authorized User or other third party. Subscriber warrants and represents
        that it either owns or has the right to provide all Subscriber Data. Subscriber hereby grants Investor’s AI a
        non-exclusive, transferable, royalty-free license to use the Subscriber Data to provide the Service and as
        otherwise described in herein or in our Privacy Policy. As stated in the Privacy Policy, we take reasonable
        steps to protect the Subscriber Data from loss, misuse, and unauthorized access, disclosure, alteration, or
        destruction. For the avoidance of doubt, in no event will we share the project information that you upload
        into the Service with third parties for marketing purposes.</p>
      <p>All right, title, and interest in and to the Service, the Website, the App, and any information, data,
        software, graphics, and interactive features contained therein, including all modifications, improvements,
        adaptations, enhancements, or translations made thereto, and all proprietary rights in any of the foregoing
        (collectively, "Investor’s AI Property"), shall be and remain the sole and exclusive property of
        Investor’s AI.</p>
      <p>Subscriber will not, and will not permit any Authorized User or other third party to:
        <ul>
          <li> allow anyone other than an Authorized User to access or use the Service;</li>
          <li> use the Service in any way that is not expressly permitted by this Agreement, including, without
            limitation, reverse engineering, modifying, copying, distributing, or sublicensing the Service, or
            introducing into the Service any software, virus, or code; </li>
          <li> use the Service in violation of any applicable law or regulation.</li>
        </ul>
      </p>

      <h2>TERMINATION AND CANCELLATION</h2>
      <p>Investor’s AI may suspend or terminate your access to and use of the Service, in whole or in part, at any
        time and for any reason; provided, however, that if you have purchased a subscription for the Service,
        Investor’s AI right to suspend or terminate your access to and use of the Service will be limited to cases
        where you have failed to pay the applicable subscription fees or have otherwise breached these Terms of
        Service, and have not cured such payment failure or other breach within 10 business days of receiving
        written notice of such payment failure or other breach from Investor’s AI (and provided, further that
        Investor’s AI may suspend your access to and use of the Service immediately without notice in the event
        that Investor’s AI reasonably determines that your account may cause potential harm to Investor’s AI or
        third parties). You may terminate your account at any time upon notice to us; provided, however, that if
        you have purchased a subscription for the Service, your right to terminate your account before paying the
        full amount of fees for the subscription period that you have committed to will be limited to cases where
        Investor’s AI has breached these Terms of Service, and has not cured such breach within 10 business days of
        receiving written notice of such breach from you. In the event of suspension or termination (other than
        cases where Investor’s AI locks your account due to fraudulent activities or other potential harm to
        Investor’s AI or third parties), Investor’s AI will provide you with access to your Subscriber Data for
        at least 30 days following such termination. It is your responsibility to keep backup copies of the
        Subscriber Data.</p>

      <h2>WARRANTY DISCLAIMER</h2>
      <p>THE SERVICE, IS PROVIDED “AS IS,” WITHOUT WARRANTY OF ANY KIND. WITHOUT LIMITING THE FOREGOING, WE
        EXPRESSLY DISCLAIM ALL WARRANTIES, WHETHER EXPRESS, IMPLIED OR STATUTORY, REGARDING THE SERVICE INCLUDING
        WITHOUT LIMITATION ANY WARRANTY OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, TITLE, SECURITY,
        ACCURACY AND NON-INFRINGEMENT. WITHOUT LIMITING THE FOREGOING, WE MAKE NO WARRANTY OR REPRESENTATION THAT
        ACCESS TO OR OPERATION OF THE SERVICE WILL BE UNINTERRUPTED OR ERROR FREE. YOU ASSUME FULL RESPONSIBILITY
        AND RISK OF LOSS RESULTING FROM YOUR DOWNLOADING AND/OR USE OF FILES, INFORMATION, CONTENT OR OTHER MATERIAL
        OBTAINED FROM THE SERVICE. SOME JURISDICTIONS LIMIT OR DO NOT PERMIT DISCLAIMERS OF WARRANTY, SO THIS
        PROVISION MAY NOT APPLY TO YOU.</p>

      <h2>LIMITATION OF DAMAGES</h2>
      <p>TO THE EXTENT PERMITTED BY APPLICABLE LAW, IN NO EVENT SHALL THE SITE, THE SERVICE, ITS AFFILIATES,
        DIRECTORS, OR EMPLOYEES, OR ITS LICENSORS OR PARTNERS, BE LIABLE TO YOU FOR ANY LOSS OF PROFITS, USE,
        OR DATA, OR FOR ANY INCIDENTAL, INDIRECT, SPECIAL, CONSEQUENTIAL OR EXEMPLARY DAMAGES, HOWEVER ARISING,
        THAT RESULT FROM: (A) THE USE, DISCLOSURE, OR DISPLAY OF YOUR USER CONTENT; (B) YOUR USE OR INABILITY TO
        USE THE SERVICE; (C) THE SERVICE GENERALLY OR THE SOFTWARE OR SYSTEMS THAT MAKE THE SERVICE AVAILABLE; OR
        (D) ANY OTHER INTERACTIONS WITH USE OR WITH ANY OTHER USER OF THE SERVICE, WHETHER BASED ON WARRANTY,
        CONTRACT, TORT (INCLUDING NEGLIGENCE) OR ANY OTHER LEGAL THEORY, AND WHETHER OR NOT WE HAVE BEEN INFORMED
        OF THE POSSIBILITY OF SUCH DAMAGE, AND EVEN IF A REMEDY SET FORTH HEREIN IS FOUND TO HAVE FAILED OF ITS
        ESSENTIAL PURPOSE. SOME JURISDICTIONS LIMIT OR DO NOT PERMIT DISCLAIMERS OF LIABILITY, SO THIS PROVISION
        MAY NOT APPLY TO YOU.</p>

      <h2>MODIFICATION OF TERMS OF USE</h2>
      <p>We can amend these Terms of Use at any time and will update these Terms of Use in the event of any such
        amendments. It is your sole responsibility to check the Site from time to time to view any such changes
        in this agreement. Your continued use of the Site or the Service signifies your agreement to our revisions
        to these Terms of Use. We will endeavor to notify you of material changes to the Terms by posting a notice
        within the Service and/or sending an email to the email address you provided to us upon registration. For
        this additional reason, you should keep your contact and profile information current. Any changes to these
        Terms (other than as set forth in this paragraph) or waiver of our rights hereunder shall not be valid or
        effective except in a written agreement bearing the physical signature of one of our officers. No purported
        waiver or modification of this agreement on our part via telephonic or email communications shall be valid.</p>

      <h2>GENERAL TERMS</h2>
      <p>If any part of this Terms of Use agreement is held or found to be invalid or unenforceable, that portion
        of the agreement will be construed as to be consistent with applicable law while the remaining portions of
        the agreement will remain in full force and effect. Any failure on our part to enforce any provision of this
        agreement will not be considered a waiver of our right to enforce such provision. Our rights under this
        agreement survive any transfer or termination of this agreement.</p>

      <p>You agree that any cause of action related to or arising out of your relationship with the Company must
        commence within ONE year after the cause of action accrues. Otherwise, such cause of action is permanently
        barred.</p>

      <p>These Terms of Use and your use of the Site are governed by the federal laws of the United States of America
        and the laws of the State of Colorado, without regard to conflict of law provisions.</p>

      <p>We may assign or delegate these Terms of Service and/or our Privacy Policy, in whole or in part, to any
        person or entity at any time with or without your consent. You may not assign or delegate any rights or
        obligations under the Terms of Service or Privacy Policy without our prior written consent, and any
        unauthorized assignment or delegation by you is void.</p>

      <p>YOU ACKNOWLEDGE THAT YOU HAVE READ THESE TERMS OF USE, UNDERSTAND THE TERMS OF USE, AND WILL BE BOUND BY
        THESE TERMS AND CONDITIONS. YOU FURTHER ACKNOWLEDGE THAT THESE TERMS OF USE TOGETHER WITH THE PRIVACY POLICY
        AT investors-ai.com/privacy REPRESENT THE COMPLETE AND EXCLUSIVE STATEMENT OF THE AGREEMENT BETWEEN US AND
        THAT IT SUPERSEDES ANY PROPOSAL OR PRIOR AGREEMENT ORAL OR WRITTEN, AND ANY OTHER COMMUNICATIONS BETWEEN US
        RELATING TO THE SUBJECT MATTER OF THIS AGREEMENT.</p>
    </div>
    <aifooter />
  </div>
</template>

<script>
  import aifooter from '../../components/footer.vue'

  export default {
    components: {
      aifooter,
    },
  }

</script>